"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Edit = void 0;
/*
 * © 2022 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Edit = ({ colour = "#E6E6E6", size = 16, }) => (react_1.default.createElement(Base_1.Base, { size: size, fill: colour, smooth: true },
    react_1.default.createElement("path", { d: "M9.9 4 12 6.1l-7.8 7.8L1 15l1.1-3.2L9.9 4zM12.4 1.6l2.1 2.1-1.4 1.4L11 3l1.4-1.4z" })));
exports.Edit = Edit;
//# sourceMappingURL=Edit.js.map